/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AgentComparisonResponse } from '../models/AgentComparisonResponse';
import type { AgentTrendResponse } from '../models/AgentTrendResponse';
import type { AgentVariantsResponse } from '../models/AgentVariantsResponse';
import type { AgentVariantsUpdate } from '../models/AgentVariantsUpdate';
import type { BulkActionJobStatusResponse } from '../models/BulkActionJobStatusResponse';
import type { BulkActionSubmitRequest } from '../models/BulkActionSubmitRequest';
import type { BulkActionSubmitResponse } from '../models/BulkActionSubmitResponse';
import type { BulkActionTargetsResponse } from '../models/BulkActionTargetsResponse';
import type { BulkStartRequest } from '../models/BulkStartRequest';
import type { BulkStartResponse } from '../models/BulkStartResponse';
import type { BulkTransitionRequest } from '../models/BulkTransitionRequest';
import type { BulkTransitionResponse } from '../models/BulkTransitionResponse';
import type { CampaignCopyRequest } from '../models/CampaignCopyRequest';
import type { CampaignCreate } from '../models/CampaignCreate';
import type { CampaignExportBundle_Output } from '../models/CampaignExportBundle_Output';
import type { CampaignImportRequest } from '../models/CampaignImportRequest';
import type { CampaignImportResult } from '../models/CampaignImportResult';
import type { CampaignResponse } from '../models/CampaignResponse';
import type { CampaignTransferRequest } from '../models/CampaignTransferRequest';
import type { CampaignUpdate } from '../models/CampaignUpdate';
import type { ContactBulkDeleteRequest } from '../models/ContactBulkDeleteRequest';
import type { ContactCreate } from '../models/ContactCreate';
import type { ContactResponse } from '../models/ContactResponse';
import type { ContactStateMachineResponse } from '../models/ContactStateMachineResponse';
import type { ContactStateResponse } from '../models/ContactStateResponse';
import type { ContactUpdate } from '../models/ContactUpdate';
import type { DynamicMonitoringResponse } from '../models/DynamicMonitoringResponse';
import type { EventAnalyticsResponse } from '../models/EventAnalyticsResponse';
import type { EventRuleAdminDTO } from '../models/EventRuleAdminDTO';
import type { EventRuleCreateRequest } from '../models/EventRuleCreateRequest';
import type { EventRulesListResponse } from '../models/EventRulesListResponse';
import type { EventRuleUpdateRequest } from '../models/EventRuleUpdateRequest';
import type { HumanInputRequest } from '../models/HumanInputRequest';
import type { HumanInputResponse } from '../models/HumanInputResponse';
import type { LlmDefaultModelResponse } from '../models/LlmDefaultModelResponse';
import type { LlmTestModelRequest } from '../models/LlmTestModelRequest';
import type { LlmTestModelResponse } from '../models/LlmTestModelResponse';
import type { OrganizationSecretResponse } from '../models/OrganizationSecretResponse';
import type { OrganizationSecretSetRequest } from '../models/OrganizationSecretSetRequest';
import type { PaginatedCampaignMonitoringResponse } from '../models/PaginatedCampaignMonitoringResponse';
import type { PaginatedCampaignsResponse } from '../models/PaginatedCampaignsResponse';
import type { PaginatedContactsResponse } from '../models/PaginatedContactsResponse';
import type { PaginatedMessageHistoryResponse } from '../models/PaginatedMessageHistoryResponse';
import type { PaginatedNotificationsResponse } from '../models/PaginatedNotificationsResponse';
import type { PaginatedPromptsResponse } from '../models/PaginatedPromptsResponse';
import type { PaginatedTasksResponse } from '../models/PaginatedTasksResponse';
import type { PhoneCallAnalyticsResponse } from '../models/PhoneCallAnalyticsResponse';
import type { PhoneCallDensityResponse } from '../models/PhoneCallDensityResponse';
import type { PromptCreate } from '../models/PromptCreate';
import type { PromptResponse } from '../models/PromptResponse';
import type { PromptUpdate } from '../models/PromptUpdate';
import type { StreakTargetsResponse } from '../models/StreakTargetsResponse';
import type { TaskResponse } from '../models/TaskResponse';
import type { TaskUpdate } from '../models/TaskUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminApiProxiedService {
    /**
     * Get Tasks
     * @param contactId Filter by the contact's UUID.
     * @param campaignId
     * @param status
     * @param statuses Filter to tasks whose status is any of these values (repeat the param: ?statuses=pending&statuses=failed). A non-empty list takes priority over 'status'.
     * @param taskType
     * @param search Match against the contact's name, email, or phone.
     * @param reasoning Case-insensitive substring match on the task's reasoning text (why it was postponed/skipped/blocked/failed), e.g. 'max calls per period' or 'parallel call'.
     * @param createdFrom Only tasks created at or after this timestamp.
     * @param createdTo Only tasks created at or before this timestamp.
     * @param scheduledFrom Only tasks scheduled at or after this timestamp.
     * @param scheduledTo Only tasks scheduled at or before this timestamp.
     * @param sort Sort field and direction, e.g. 'scheduled_at:desc', 'status:asc'. Sortable fields: scheduled_at, created_at, updated_at, executed_at, status, task_type.
     * @param limit
     * @param offset
     * @returns PaginatedTasksResponse Successful Response
     * @throws ApiError
     */
    public static getTasksAdminTasksGet(
        contactId?: (string | null),
        campaignId?: (string | null),
        status?: (string | null),
        statuses?: (Array<string> | null),
        taskType?: (string | null),
        search?: (string | null),
        reasoning?: (string | null),
        createdFrom?: (string | null),
        createdTo?: (string | null),
        scheduledFrom?: (string | null),
        scheduledTo?: (string | null),
        sort?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<PaginatedTasksResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/tasks',
            query: {
                'contact_id': contactId,
                'campaign_id': campaignId,
                'status': status,
                'statuses': statuses,
                'task_type': taskType,
                'search': search,
                'reasoning': reasoning,
                'created_from': createdFrom,
                'created_to': createdTo,
                'scheduled_from': scheduledFrom,
                'scheduled_to': scheduledTo,
                'sort': sort,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Task
     * @param taskId
     * @returns TaskResponse Successful Response
     * @throws ApiError
     */
    public static getTaskAdminTasksTaskIdGet(
        taskId: string,
    ): CancelablePromise<TaskResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/tasks/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Task
     * @param taskId
     * @param requestBody
     * @returns TaskResponse Successful Response
     * @throws ApiError
     */
    public static updateTaskAdminTasksTaskIdPatch(
        taskId: string,
        requestBody: TaskUpdate,
    ): CancelablePromise<TaskResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/tasks/{task_id}',
            path: {
                'task_id': taskId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Task
     * @param taskId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteTaskAdminTasksTaskIdDelete(
        taskId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/tasks/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Submit Bulk Action
     * Enqueue a bulk action over a filter-selected set of contacts.
     * @param requestBody
     * @returns BulkActionSubmitResponse Successful Response
     * @throws ApiError
     */
    public static submitBulkActionAdminBulkActionsPost(
        requestBody: BulkActionSubmitRequest,
    ): CancelablePromise<BulkActionSubmitResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/bulk-actions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Bulk Action
     * Status summary for one job (counts, timestamps, error).
     * @param jobId
     * @returns BulkActionJobStatusResponse Successful Response
     * @throws ApiError
     */
    public static getBulkActionAdminBulkActionsJobIdGet(
        jobId: string,
    ): CancelablePromise<BulkActionJobStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/bulk-actions/{job_id}',
            path: {
                'job_id': jobId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Bulk Action Targets
     * Paginated per-contact results — pass ``status=failed`` to list failures.
     * @param jobId
     * @param status Filter by target status (pending/done/failed)
     * @param limit
     * @param offset
     * @returns BulkActionTargetsResponse Successful Response
     * @throws ApiError
     */
    public static getBulkActionTargetsAdminBulkActionsJobIdTargetsGet(
        jobId: string,
        status?: (string | null),
        limit: number = 50,
        offset?: number,
    ): CancelablePromise<BulkActionTargetsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/bulk-actions/{job_id}/targets',
            path: {
                'job_id': jobId,
            },
            query: {
                'status': status,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Notifications
     * Newest-first org feed; live bulk-action counts projected per item.
     * @param limit
     * @param offset
     * @returns PaginatedNotificationsResponse Successful Response
     * @throws ApiError
     */
    public static getNotificationsAdminNotificationsGet(
        limit: number = 20,
        offset?: number,
    ): CancelablePromise<PaginatedNotificationsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/notifications',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Contacts
     * @param email
     * @param phone
     * @param campaignId
     * @param requiresHumanInput
     * @param search
     * @param latestContactState
     * @param latestContactStates Filter to contacts whose latest state is any of these values (repeat the param: ?latest_contact_states=a&latest_contact_states=b). A non-empty list takes priority over 'latest_contact_state'. The tokens 'none'/'null' match contacts with no state yet.
     * @param updatedFrom
     * @param updatedTo
     * @param createdFrom
     * @param createdTo
     * @param sort Sort field and direction, e.g. 'created_at:desc', 'email:asc'. Sortable fields: created_at, updated_at, email, first_name, last_name, phone
     * @param limit
     * @param offset
     * @returns PaginatedContactsResponse Successful Response
     * @throws ApiError
     */
    public static getContactsAdminContactsGet(
        email?: (string | null),
        phone?: (string | null),
        campaignId?: (string | null),
        requiresHumanInput?: (boolean | null),
        search?: (string | null),
        latestContactState?: (string | null),
        latestContactStates?: (Array<string> | null),
        updatedFrom?: (string | null),
        updatedTo?: (string | null),
        createdFrom?: (string | null),
        createdTo?: (string | null),
        sort?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<PaginatedContactsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/contacts',
            query: {
                'email': email,
                'phone': phone,
                'campaign_id': campaignId,
                'requires_human_input': requiresHumanInput,
                'search': search,
                'latest_contact_state': latestContactState,
                'latest_contact_states': latestContactStates,
                'updated_from': updatedFrom,
                'updated_to': updatedTo,
                'created_from': createdFrom,
                'created_to': createdTo,
                'sort': sort,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Contact
     * @param requestBody
     * @returns ContactResponse Successful Response
     * @throws ApiError
     */
    public static createContactAdminContactsPost(
        requestBody: ContactCreate,
    ): CancelablePromise<ContactResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/contacts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Contacts Csv
     * @param campaignId Campaign ID (required)
     * @param email
     * @param phone
     * @param requiresHumanInput
     * @param search
     * @param latestContactState
     * @param latestContactStates Filter to contacts whose latest state is any of these values (repeat the param). A non-empty list takes priority over 'latest_contact_state'.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static exportContactsCsvAdminContactsExportCsvGet(
        campaignId: string,
        email?: (string | null),
        phone?: (string | null),
        requiresHumanInput?: (boolean | null),
        search?: (string | null),
        latestContactState?: (string | null),
        latestContactStates?: (Array<string> | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/contacts/export-csv',
            query: {
                'campaign_id': campaignId,
                'email': email,
                'phone': phone,
                'requires_human_input': requiresHumanInput,
                'search': search,
                'latest_contact_state': latestContactState,
                'latest_contact_states': latestContactStates,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Delete Contacts
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static bulkDeleteContactsAdminContactsBulkDeletePost(
        requestBody: ContactBulkDeleteRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/contacts/bulk-delete',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Start Contacts
     * @param requestBody
     * @returns BulkStartResponse Successful Response
     * @throws ApiError
     */
    public static bulkStartContactsAdminContactsBulkStartPost(
        requestBody: BulkStartRequest,
    ): CancelablePromise<BulkStartResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/contacts/bulk-start',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Bulk Transition Contacts
     * Transition contacts to an admin-assignable state.
     *
     * Per-contact validation against the canonical state machine; ineligible
     * contacts are reported as ``skipped`` with a reason instead of failing
     * the batch. ``GET /api/admin/contact-states/machine`` describes the
     * allowed targets and guards.
     *
     * Auth: an Auth0 JWT (UI) or a long-lived org API key — external systems
     * send ``Authorization: Bearer <org_api_key>`` plus the
     * ``x-ai-agent-organization-context`` header.
     * @param requestBody
     * @returns BulkTransitionResponse Successful Response
     * @throws ApiError
     */
    public static bulkTransitionContactsAdminContactsBulkTransitionPost(
        requestBody: BulkTransitionRequest,
    ): CancelablePromise<BulkTransitionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/contacts/bulk-transition',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Contact By Email
     * @param email
     * @param cascade Delete all related data (messages, tasks, events)
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteContactByEmailAdminContactsByEmailEmailDelete(
        email: string,
        cascade: boolean = true,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/contacts/by-email/{email}',
            path: {
                'email': email,
            },
            query: {
                'cascade': cascade,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Contact
     * @param contactId
     * @returns ContactResponse Successful Response
     * @throws ApiError
     */
    public static getContactAdminContactsContactIdGet(
        contactId: string,
    ): CancelablePromise<ContactResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/contacts/{contact_id}',
            path: {
                'contact_id': contactId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Contact
     * @param contactId
     * @param requestBody
     * @returns ContactResponse Successful Response
     * @throws ApiError
     */
    public static updateContactAdminContactsContactIdPatch(
        contactId: string,
        requestBody: ContactUpdate,
    ): CancelablePromise<ContactResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/contacts/{contact_id}',
            path: {
                'contact_id': contactId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Contact
     * @param contactId
     * @param cascade Delete all related data (messages, tasks, events)
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteContactAdminContactsContactIdDelete(
        contactId: string,
        cascade: boolean = true,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/contacts/{contact_id}',
            path: {
                'contact_id': contactId,
            },
            query: {
                'cascade': cascade,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Clean Contact Data
     * @param contactId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static cleanContactDataAdminContactsContactIdCleanPost(
        contactId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/contacts/{contact_id}/clean',
            path: {
                'contact_id': contactId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Contact State
     * @param contactId
     * @returns ContactStateResponse Successful Response
     * @throws ApiError
     */
    public static getContactStateAdminContactsContactIdStateGet(
        contactId: string,
    ): CancelablePromise<Array<ContactStateResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/contacts/{contact_id}/state',
            path: {
                'contact_id': contactId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Message History
     * @param contactId
     * @param limit
     * @param offset
     * @param channel
     * @param order Order by message_timestamp. 'desc' (default) is newest-first; 'asc' is oldest-first.
     * @returns PaginatedMessageHistoryResponse Successful Response
     * @throws ApiError
     */
    public static getMessageHistoryAdminContactsContactIdMessageHistoryGet(
        contactId: string,
        limit: number = 50,
        offset?: number,
        channel?: (string | null),
        order: 'asc' | 'desc' = 'desc',
    ): CancelablePromise<PaginatedMessageHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/contacts/{contact_id}/message-history',
            path: {
                'contact_id': contactId,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'channel': channel,
                'order': order,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Contact State Machine
     * Describe the contact state machine for UI option rendering.
     *
     * Without ``campaign_id`` this returns just the immutable defaults. With one,
     * the campaign's configured custom states are appended (``immutable: false``,
     * each carrying its configured ``action`` and admin-assignable from any
     * state). ``rules`` lists every admin-assignable target with its guards
     * (``allowed_from`` of ``null`` means any current state). Transitions out of
     * ``sensitive_source_states`` require an explicit ``reason`` in
     * ``POST /api/admin/contacts/bulk-transition``.
     * @param campaignId
     * @returns ContactStateMachineResponse Successful Response
     * @throws ApiError
     */
    public static getContactStateMachineAdminContactStatesMachineGet(
        campaignId?: (string | null),
    ): CancelablePromise<ContactStateMachineResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/contact-states/machine',
            query: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Distinct Contact States
     * @param campaignId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getDistinctContactStatesAdminContactStatesDistinctGet(
        campaignId?: (string | null),
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/contact-states/distinct',
            query: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Prompts
     * @param promptType
     * @param campaignId
     * @param isActive
     * @param limit
     * @param offset
     * @returns PaginatedPromptsResponse Successful Response
     * @throws ApiError
     */
    public static getPromptsAdminPromptsGet(
        promptType?: (string | null),
        campaignId?: (string | null),
        isActive?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<PaginatedPromptsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/prompts',
            query: {
                'prompt_type': promptType,
                'campaign_id': campaignId,
                'is_active': isActive,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Prompt
     * @param requestBody
     * @returns PromptResponse Successful Response
     * @throws ApiError
     */
    public static createPromptAdminPromptsPost(
        requestBody: PromptCreate,
    ): CancelablePromise<PromptResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/prompts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Prompt
     * @param promptId
     * @returns PromptResponse Successful Response
     * @throws ApiError
     */
    public static getPromptAdminPromptsPromptIdGet(
        promptId: string,
    ): CancelablePromise<PromptResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/prompts/{prompt_id}',
            path: {
                'prompt_id': promptId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Prompt
     * @param promptId
     * @param requestBody
     * @returns PromptResponse Successful Response
     * @throws ApiError
     */
    public static updatePromptAdminPromptsPromptIdPatch(
        promptId: string,
        requestBody: PromptUpdate,
    ): CancelablePromise<PromptResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/prompts/{prompt_id}',
            path: {
                'prompt_id': promptId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Prompt
     * @param promptId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deletePromptAdminPromptsPromptIdDelete(
        promptId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/prompts/{prompt_id}',
            path: {
                'prompt_id': promptId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Llm Default Model
     * @returns LlmDefaultModelResponse Successful Response
     * @throws ApiError
     */
    public static getLlmDefaultModelAdminLlmDefaultModelGet(): CancelablePromise<LlmDefaultModelResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/llm/default-model',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Test Llm Model
     * Probe a model with the system or campaign-scoped OpenRouter key.
     * @param requestBody
     * @param campaignId
     * @returns LlmTestModelResponse Successful Response
     * @throws ApiError
     */
    public static testLlmModelAdminLlmTestModelPost(
        requestBody: LlmTestModelRequest,
        campaignId?: (string | null),
    ): CancelablePromise<LlmTestModelResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/llm/test-model',
            query: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Organization Secrets
     * @returns OrganizationSecretResponse Successful Response
     * @throws ApiError
     */
    public static listOrganizationSecretsAdminOrganizationSecretsGet(): CancelablePromise<Array<OrganizationSecretResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/organization-secrets',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Organization Secret
     * @param keyName
     * @returns OrganizationSecretResponse Successful Response
     * @throws ApiError
     */
    public static getOrganizationSecretAdminOrganizationSecretsKeyNameGet(
        keyName: string,
    ): CancelablePromise<OrganizationSecretResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/organization-secrets/{key_name}',
            path: {
                'key_name': keyName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Organization Secret
     * @param keyName
     * @param requestBody
     * @returns OrganizationSecretResponse Successful Response
     * @throws ApiError
     */
    public static setOrganizationSecretAdminOrganizationSecretsKeyNamePut(
        keyName: string,
        requestBody: OrganizationSecretSetRequest,
    ): CancelablePromise<OrganizationSecretResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/organization-secrets/{key_name}',
            path: {
                'key_name': keyName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Organization Secret
     * @param keyName
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteOrganizationSecretAdminOrganizationSecretsKeyNameDelete(
        keyName: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/organization-secrets/{key_name}',
            path: {
                'key_name': keyName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaigns
     * @param status
     * @param limit
     * @param offset
     * @returns PaginatedCampaignsResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignsAdminCampaignsGet(
        status?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<PaginatedCampaignsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/campaigns',
            query: {
                'status': status,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Campaign
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static createCampaignAdminCampaignsPost(
        requestBody: CampaignCreate,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/campaigns',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaign
     * Get a single campaign by id, including the selected org-credential
     * name (``llm_credential_key_name``).
     * @param campaignId
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignAdminCampaignsCampaignIdGet(
        campaignId: string,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Campaign
     * @param campaignId
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static updateCampaignAdminCampaignsCampaignIdPatch(
        campaignId: string,
        requestBody: CampaignUpdate,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Campaign
     * @param campaignId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteCampaignAdminCampaignsCampaignIdDelete(
        campaignId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/campaigns/{campaign_id}',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Copy Campaign
     * @param campaignId
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static copyCampaignAdminCampaignsCampaignIdCopyPost(
        campaignId: string,
        requestBody?: (CampaignCopyRequest | null),
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/campaigns/{campaign_id}/copy',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Transfer Campaign
     * @param campaignId
     * @param requestBody
     * @returns CampaignResponse Successful Response
     * @throws ApiError
     */
    public static transferCampaignAdminCampaignsCampaignIdTransferPost(
        campaignId: string,
        requestBody: CampaignTransferRequest,
    ): CancelablePromise<CampaignResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/campaigns/{campaign_id}/transfer',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Export Campaign
     * Export a campaign settings, prompts and secret-key placeholders as JSON
     * @param campaignId
     * @returns CampaignExportBundle_Output Successful Response
     * @throws ApiError
     */
    public static exportCampaignAdminCampaignsCampaignIdExportGet(
        campaignId: string,
    ): CancelablePromise<CampaignExportBundle_Output> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/campaigns/{campaign_id}/export',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Import Campaign
     * Import a bundle produced by :func:`export_campaign` into the caller's
     * organization. By default a new campaign is created; pass
     * ``target_campaign_id`` to overwrite an existing campaign in place
     * (preserving its id, name and status). The bundle's ``schema_version`` must
     * match the server's supported version.
     * @param requestBody
     * @returns CampaignImportResult Successful Response
     * @throws ApiError
     */
    public static importCampaignAdminCampaignsImportPost(
        requestBody: CampaignImportRequest,
    ): CancelablePromise<CampaignImportResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/campaigns/import',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Agent Variants
     * The campaign's caller-agent A/B variants (up to 5 active).
     *
     * A campaign with no variants splits nothing and dials with its
     * ``default_agent_id``; the response ``variants`` list is then empty.
     * @param campaignId
     * @returns AgentVariantsResponse Successful Response
     * @throws ApiError
     */
    public static getAgentVariantsAdminCampaignsCampaignIdAgentVariantsGet(
        campaignId: string,
    ): CancelablePromise<AgentVariantsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/campaigns/{campaign_id}/agent-variants',
            path: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Replace Agent Variants
     * Replace the campaign's caller-agent variant set (replace-managed).
     *
     * Accepts up to 5 active variants ``{agent_id, label, weight, active}``
     * (validated: ≤5 active, weights ≥ 0, non-empty agent_ids/labels). An empty
     * list clears the split so the campaign falls back to ``default_agent_id``.
     * @param campaignId
     * @param requestBody
     * @returns AgentVariantsResponse Successful Response
     * @throws ApiError
     */
    public static replaceAgentVariantsAdminCampaignsCampaignIdAgentVariantsPut(
        campaignId: string,
        requestBody: AgentVariantsUpdate,
    ): CancelablePromise<AgentVariantsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/campaigns/{campaign_id}/agent-variants',
            path: {
                'campaign_id': campaignId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start Campaign Admin
     * Kick off a campaign for a contact (admin endpoint).
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static startCampaignAdminAdminCampaignsStartPost(
        requestBody: Record<string, any>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/campaigns/start',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaign Monitoring
     * @param campaignId
     * @param search
     * @param latestContactState
     * @param latestContactStates Filter to contacts whose latest state is any of these values (repeat the param: ?latest_contact_states=a&latest_contact_states=b). A non-empty list takes priority over 'latest_contact_state'. The tokens 'none'/'null' match contacts with no state yet.
     * @param sort Sort field and direction, e.g. 'contact_name:asc', 'latest_contact_state:desc'. Any displayed column key is sortable, including JSON paths like 'metadata.last_call_result' and 'metadata.already_known_data.callback_date_time'.
     * @param updatedFrom
     * @param updatedTo
     * @param createdFrom
     * @param createdTo
     * @param limit
     * @param offset
     * @returns PaginatedCampaignMonitoringResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignMonitoringAdminCampaignMonitoringGet(
        campaignId?: (string | null),
        search?: (string | null),
        latestContactState?: (string | null),
        latestContactStates?: (Array<string> | null),
        sort?: (string | null),
        updatedFrom?: (string | null),
        updatedTo?: (string | null),
        createdFrom?: (string | null),
        createdTo?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<PaginatedCampaignMonitoringResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/campaign-monitoring',
            query: {
                'campaign_id': campaignId,
                'search': search,
                'latest_contact_state': latestContactState,
                'latest_contact_states': latestContactStates,
                'sort': sort,
                'updated_from': updatedFrom,
                'updated_to': updatedTo,
                'created_from': createdFrom,
                'created_to': createdTo,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaign Monitoring Dynamic
     * @param campaignId
     * @param search
     * @param latestContactState
     * @param latestContactStates Filter to contacts whose latest state is any of these values (repeat the param: ?latest_contact_states=a&latest_contact_states=b). A non-empty list takes priority over 'latest_contact_state'. The tokens 'none'/'null' match contacts with no state yet.
     * @param sort Sort field and direction, e.g. 'contact_name:asc', 'latest_contact_state:desc'. Any displayed column key is sortable, including JSON paths like 'metadata.last_call_result' and 'metadata.already_known_data.callback_date_time'.
     * @param filter Repeatable per-field filter '<field>:<op>[:<value>]'. Ops: eq, ne, contains, gte, lte, in (comma-separated value), isnull (value true/false). Field may be any displayed column key, e.g. 'metadata.last_call_result:eq:voice mail', 'created_at:gte:2026-06-01T00:00:00+00:00', 'metadata.already_known_data.callback_date_time:isnull:false'.
     * @param updatedFrom
     * @param updatedTo
     * @param createdFrom
     * @param createdTo
     * @param limit
     * @param offset
     * @returns DynamicMonitoringResponse Successful Response
     * @throws ApiError
     */
    public static getCampaignMonitoringDynamicAdminCampaignMonitoringDynamicGet(
        campaignId?: (string | null),
        search?: (string | null),
        latestContactState?: (string | null),
        latestContactStates?: (Array<string> | null),
        sort?: (string | null),
        filter?: (Array<string> | null),
        updatedFrom?: (string | null),
        updatedTo?: (string | null),
        createdFrom?: (string | null),
        createdTo?: (string | null),
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<DynamicMonitoringResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/campaign-monitoring/dynamic',
            query: {
                'campaign_id': campaignId,
                'search': search,
                'latest_contact_state': latestContactState,
                'latest_contact_states': latestContactStates,
                'sort': sort,
                'filter': filter,
                'updated_from': updatedFrom,
                'updated_to': updatedTo,
                'created_from': createdFrom,
                'created_to': createdTo,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Submit Human Input
     * @param requestBody
     * @returns HumanInputResponse Successful Response
     * @throws ApiError
     */
    public static submitHumanInputAdminHumanInputPost(
        requestBody: HumanInputRequest,
    ): CancelablePromise<HumanInputResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/human-input',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Event Analytics
     * Bucketed counts over the ``platform_events`` log plus period totals.
     *
     * Buckets are (time bucket × event type × payload outcome) counts; the
     * totals block includes the pickup rate — answered / all ``call.ended``
     * events in the period (0 when there were no calls).
     * @param dateFrom Only events at/after this instant (ISO datetime).
     * @param dateTo Only events before this instant (ISO datetime, exclusive).
     * @param campaignId Restrict to a single campaign (org-owned).
     * @param eventTypes Repeatable event-type filter; defaults to the call events (call.ended, voicemail.detected).
     * @param granularity Time-bucket size: day | hour.
     * @returns EventAnalyticsResponse Successful Response
     * @throws ApiError
     */
    public static getEventAnalyticsAdminAnalyticsEventsGet(
        dateFrom: string,
        dateTo: string,
        campaignId?: (string | null),
        eventTypes?: Array<string>,
        granularity: string = 'day',
    ): CancelablePromise<EventAnalyticsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/analytics/events',
            query: {
                'date_from': dateFrom,
                'date_to': dateTo,
                'campaign_id': campaignId,
                'event_types': eventTypes,
                'granularity': granularity,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Phone Call Density
     * Binned overview of completed calls (time × duration × status).
     *
     * This is the default dashboard query: it returns a few hundred aggregated
     * cells regardless of call volume, so the response stays small and cheap to
     * serialize. Use ``/phone-calls`` to drill a single bin into raw points.
     * @param campaignId Restrict to a single campaign (org-owned).
     * @param startedFrom Only calls started at/after this instant.
     * @param startedTo Only calls started before this instant.
     * @param granularity Time-bucket size: hour | day | week | month. Auto-chosen from the date span when omitted.
     * @returns PhoneCallDensityResponse Successful Response
     * @throws ApiError
     */
    public static getPhoneCallDensityAdminAnalyticsPhoneCallsDensityGet(
        campaignId?: (string | null),
        startedFrom?: (string | null),
        startedTo?: (string | null),
        granularity?: (string | null),
    ): CancelablePromise<PhoneCallDensityResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/analytics/phone-calls/density',
            query: {
                'campaign_id': campaignId,
                'started_from': startedFrom,
                'started_to': startedTo,
                'granularity': granularity,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Phone Call Analytics
     * Raw scatter points for completed phone calls in the caller's org.
     *
     * Each point is one call: ``started_at`` (time axis), ``duration_seconds``
     * (magnitude axis) and ``call_status`` (colour: connected / no_answer /
     * voicemail). Intended for drilling into a single density bin or a narrow
     * window — pass the bin's time/duration/status bounds to keep it bounded.
     * @param campaignId Restrict to a single campaign (org-owned).
     * @param startedFrom Only calls started at/after this instant.
     * @param startedTo Only calls started before this instant.
     * @param durationMin Only calls at/above this duration (seconds).
     * @param durationMax Only calls below this duration (seconds).
     * @param callStatus Only this status (connected / no_answer / voicemail).
     * @param limit
     * @returns PhoneCallAnalyticsResponse Successful Response
     * @throws ApiError
     */
    public static getPhoneCallAnalyticsAdminAnalyticsPhoneCallsGet(
        campaignId?: (string | null),
        startedFrom?: (string | null),
        startedTo?: (string | null),
        durationMin?: (number | null),
        durationMax?: (number | null),
        callStatus?: (string | null),
        limit: number = 5000,
    ): CancelablePromise<PhoneCallAnalyticsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/analytics/phone-calls',
            query: {
                'campaign_id': campaignId,
                'started_from': startedFrom,
                'started_to': startedTo,
                'duration_min': durationMin,
                'duration_max': durationMax,
                'call_status': callStatus,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Agent Comparison
     * Per-caller-agent rollup for one campaign's A/B test.
     *
     * One row per agent that placed a call: total calls, pickup rate (line
     * answered — connected or voicemail), user_reply conversion rate (a human
     * actually spoke), Wilson 95% confidence intervals + a sample-size flag on
     * those rates, average duration, and the distribution of the agent's contacts
     * across their latest contact state — tagged with the variant ``label``. The
     * owner reads this to pick a winner, then re-weights the variants by hand
     * (there is no automatic promotion in the MVP).
     * @param campaignId Campaign to compare caller agents within (org-owned).
     * @param startedFrom Only calls started at/after this instant.
     * @param startedTo Only calls started before this instant.
     * @returns AgentComparisonResponse Successful Response
     * @throws ApiError
     */
    public static getAgentComparisonAdminAnalyticsAgentComparisonGet(
        campaignId: string,
        startedFrom?: (string | null),
        startedTo?: (string | null),
    ): CancelablePromise<AgentComparisonResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/analytics/agent-comparison',
            query: {
                'campaign_id': campaignId,
                'started_from': startedFrom,
                'started_to': startedTo,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Agent Comparison Trend
     * Per-agent time series backing the A/B comparison trend chart.
     *
     * One point per (time bucket × agent): total calls plus the bucket's pickup
     * and user_reply rates, tagged with the variant ``label``. Buckets use the
     * same ``date_trunc`` granularity as the density overview, auto-chosen from
     * the date span when not given.
     * @param campaignId Campaign to compare caller agents within (org-owned).
     * @param startedFrom Only calls started at/after this instant.
     * @param startedTo Only calls started before this instant.
     * @param granularity Time-bucket size: hour | day | week | month. Auto-chosen from the date span when omitted.
     * @returns AgentTrendResponse Successful Response
     * @throws ApiError
     */
    public static getAgentComparisonTrendAdminAnalyticsAgentComparisonTrendGet(
        campaignId: string,
        startedFrom?: (string | null),
        startedTo?: (string | null),
        granularity?: (string | null),
    ): CancelablePromise<AgentTrendResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/analytics/agent-comparison/trend',
            query: {
                'campaign_id': campaignId,
                'started_from': startedFrom,
                'started_to': startedTo,
                'granularity': granularity,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Streak Targets
     * Selectable Streak Alert targets (e.g. "Missed call") — named
     * ``(trigger, condition)`` presets the UI offers so an admin never
     * hand-builds the outcome matcher.
     * @returns StreakTargetsResponse Successful Response
     * @throws ApiError
     */
    public static listStreakTargetsAdminEventRulesStreakTargetsGet(): CancelablePromise<StreakTargetsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/event-rules/streak-targets',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Event Rules
     * All rules visible to the caller's organization: global rules plus
     * rules scoped to campaigns the org owns.
     * @returns EventRulesListResponse Successful Response
     * @throws ApiError
     */
    public static listEventRulesAdminEventRulesGet(): CancelablePromise<EventRulesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/event-rules',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Event Rule
     * @param requestBody
     * @returns EventRuleAdminDTO Successful Response
     * @throws ApiError
     */
    public static createEventRuleAdminEventRulesPost(
        requestBody: EventRuleCreateRequest,
    ): CancelablePromise<EventRuleAdminDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/event-rules',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Event Rule
     * @param ruleId
     * @param requestBody
     * @returns EventRuleAdminDTO Successful Response
     * @throws ApiError
     */
    public static updateEventRuleAdminEventRulesRuleIdPatch(
        ruleId: string,
        requestBody: EventRuleUpdateRequest,
    ): CancelablePromise<EventRuleAdminDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/event-rules/{rule_id}',
            path: {
                'rule_id': ruleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Event Rule
     * @param ruleId
     * @returns void
     * @throws ApiError
     */
    public static deleteEventRuleAdminEventRulesRuleIdDelete(
        ruleId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/event-rules/{rule_id}',
            path: {
                'rule_id': ruleId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Integration Info
     * Return integration info (API key) for external systems like N8N.
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getIntegrationInfoAdminIntegrationInfoGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/integration-info',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
